import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import { Iconfont } from 'vuetify/types/services/icons';

Vue.use(Vuetify);

const opts = {
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: '#3f51b5',
        secondary: '#b0bec5',
        anchor: '#8c9eff',
        // 好きにカラータイプを追加可能。
        // test: '#fc5',
      },
    },
  },
} as const;

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default new Vuetify(opts);
